import React from "react";

export default function Footer() {
  return (
    <div>
      <small className="by">
          This project was coded by Stefanie Polanco 👩🏾‍💻 and is {" "}
          <a href="https://github.com/stefpolanco1/weather-app-react"
          target="_blank" rel="noreferrer">
              open-sourced on Github
          </a>
      </small>
    </div>
  );
}